import APIs from ".";
import {
  setUsersList,
  setUsersListFilters,
  setUsersListLoading,
} from "../redux/modules/users/actions";
import { deleteApi, getApi, patchtApi } from "../services/axios";

export function getUsers({
  selectedPage = 1,
  selectedPageSize,
  searchValue = "",
  deletedOnly = false,
}) {
  return async function (dispatch) {
    const res = await getApi(
      APIs.USERS.GET_USERS({
        deletedOnly,
        search: searchValue,
        selectedPage,
        selectedPageSize,
      }),
      {
        validateUser: true,
        loadingFn: setUsersListLoading,
      }
    );

    if (res.success) {
      dispatch(
        setUsersList({
          data: res.data,
          total: res.total,
        })
      );

      dispatch(
        setUsersListFilters({
          selectedPage,
          selectedPageSize,
          searchValue,
          deletedOnly,
        })
      );
    }

    return res;
  };
}

export function deleteUser(id, hardDelete = false) {
  return async function () {
    const res = await deleteApi(APIs.USERS.DELETE_USER(id, hardDelete), {
      validateUser: true,
    });

    return res;
  };
}

export function archiveUser(id) {
  return async function () {
    const res = await deleteApi(APIs.USERS.ARCHIVE_USER(id), {
      validateUser: true,
    });

    return res;
  };
}

export function unarchiveUser(id) {
  return async function () {
    const res = await patchtApi(
      APIs.USERS.UNARCHIVE_USER(id),
      {},
      {
        validateUser: true,
      }
    );

    return res;
  };
}
